module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loadingWrap"
  }, [_c('div', {
    staticClass: "icon iconfont icon-loading"
  }, [_c('span', [_vm._v("Loading...")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f5c3d24"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loading/loading.vue
// module id = 270
// module chunks = 1